import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/router';

var NVEAuthType;
(function (NVEAuthType) {
    NVEAuthType[NVEAuthType["X_AUTH_TOKEN"] = 0] = "X_AUTH_TOKEN";
    NVEAuthType[NVEAuthType["JWT_TOKEN"] = 1] = "JWT_TOKEN";
})(NVEAuthType || (NVEAuthType = {}));

class NVAuthConfigurations {
    constructor(init) {
        this.internalResetPasswordRequestEndpoint = '';
        this.internalResetPasswordPerformEndpoint = '';
        this.internalFirstChangePasswordEndpoint = '';
        this.internalVerifyOTPEndpoint = '';
        this.internalCreateOTPEndpoint = '';
        this.loginURL = '/login';
        this.notAuthorizedURL = '/notAuthorized';
        this.internalBackEndpoint = '';
        this.internalLoginEndpoint = '';
        this.internalLogoutEndpoint = '';
        this.internalChangePasswordEndpoint = '';
        this.internalProfileEndpoint = '';
        this.internalFindAllRolesEndpoint = '';
        this.internalLockEndpoint = '';
        this.internalUnlockEndpoint = '';
        this.internalAuthStorageKey = '';
        this.nvEAuthType = NVEAuthType.X_AUTH_TOKEN;
        this.internalResetPasswordRequestEndpoint = init.get('internalResetPasswordRequestEndpoint') ? init.get('internalResetPasswordRequestEndpoint') : '';
        this.internalResetPasswordPerformEndpoint = init.get('internalResetPasswordPerformEndpoint') ? init.get('internalResetPasswordPerformEndpoint') : '';
        this.internalFirstChangePasswordEndpoint = init.get('internalFirstChangePasswordEndpoint') ? init.get('internalFirstChangePasswordEndpoint') : '';
        this.internalVerifyOTPEndpoint = init.get('internalVerifyOTPEndpoint') ? init.get('internalVerifyOTPEndpoint') : '';
        this.internalCreateOTPEndpoint = init.get('internalCreateOTPEndpoint') ? init.get('internalCreateOTPEndpoint') : '';
        this.loginURL = init.get('loginURL') ? init.get('loginURL') : '/login';
        this.notAuthorizedURL = init.get('notAuthorizedURL') ? init.get('notAuthorizedURL') : '/notAuthorized';
        this.internalBackEndpoint = init.get('internalBackEndpoint') ? init.get('internalBackEndpoint') : '';
        this.internalLoginEndpoint = init.get('internalLoginEndpoint') ? init.get('internalLoginEndpoint') : '';
        this.internalLogoutEndpoint = init.get('internalLogoutEndpoint') ? init.get('internalLogoutEndpoint') : '';
        this.internalChangePasswordEndpoint = init.get('internalChangePasswordEndpoint') ? init.get('internalChangePasswordEndpoint') : '';
        this.internalProfileEndpoint = init.get('internalProfileEndpoint') ? init.get('internalProfileEndpoint') : '';
        this.internalFindAllRolesEndpoint = init.get('internalFindAllRolesEndpoint') ? init.get('internalFindAllRolesEndpoint') : '';
        this.internalLockEndpoint = init.get('internalLockEndpoint') ? init.get('internalLockEndpoint') : '';
        this.internalUnlockEndpoint = init.get('internalUnlockEndpoint') ? init.get('internalUnlockEndpoint') : '';
        this.internalAuthStorageKey = init.get('internalAuthStorageKey') ? init.get('internalAuthStorageKey') : '';
        this.nvEAuthType = init.get('nvEAuthType') ? init.get('nvEAuthType') : NVEAuthType.X_AUTH_TOKEN;
    }
}
/** @nocollapse */ NVAuthConfigurations.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVAuthConfigurations, deps: [{ token: Map }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ NVAuthConfigurations.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVAuthConfigurations, providedIn: 'root', useExisting: NVAuthConfigurations });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVAuthConfigurations, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root', useExisting: NVAuthConfigurations }]
        }], ctorParameters: function () { return [{ type: Map }]; } });

class NVAuth {
    constructor(init) {
        Object.assign(this, init);
        this.rolesSet = new Set(this.user.roles);
    }
}

class NVProfile {
    constructor(init) { Object.assign(this, init); }
}

class NVUser {
    constructor(init) { Object.assign(this, init); }
}

class NVAuthService {
    constructor(internalSessionStorageService, internalHttp, configuration) {
        this.internalSessionStorageService = internalSessionStorageService;
        this.internalHttp = internalHttp;
        this.nvEAuthType = NVEAuthType.X_AUTH_TOKEN;
        this.version = new Date().getTime();
        this.internalBackEndpoint = configuration.internalBackEndpoint;
        this.internalLoginEndpoint = configuration.internalLoginEndpoint;
        this.internalLogoutEndpoint = configuration.internalLogoutEndpoint;
        this.internalChangePasswordEndpoint = configuration.internalChangePasswordEndpoint;
        this.internalProfileEndpoint = configuration.internalProfileEndpoint;
        this.internalAuthStorageKey = configuration.internalAuthStorageKey;
        this.nvEAuthType = configuration.nvEAuthType;
        this.internalResetPasswordRequestEndpoint = configuration.internalResetPasswordRequestEndpoint;
        this.internalResetPasswordPerformEndpoint = configuration.internalResetPasswordPerformEndpoint;
        this.internalFirstChangePasswordEndpoint = configuration.internalFirstChangePasswordEndpoint;
        this.internalVerifyOTPEndpoint = configuration.internalVerifyOTPEndpoint;
        this.internalCreateOTPEndpoint = configuration.internalCreateOTPEndpoint;
    }
    login(username, password) {
        const that = this;
        const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');
        const body = `username=${username}&password=${password}`;
        this.clearContext();
        return this.internalHttp.post(this.internalBackEndpoint + this.internalLoginEndpoint, body, { headers, observe: 'response' }).pipe(map(r => {
            that.saveContext(r.body, r.headers.get(this.getResponseHeaderName()));
            return r.body;
        }));
    }
    logout() {
        const that = this;
        return that.internalHttp.get(this.internalBackEndpoint + this.internalLogoutEndpoint, {
            params: new HttpParams(),
            observe: 'response'
        }).pipe(map(r => {
            that.clearContext();
            return r.body;
        }));
    }
    changePassword(oldPassword, newPassword) {
        const that = this;
        const extraParams = new HttpParams()
            .set('oldPassword', oldPassword)
            .set('newPassword', newPassword);
        return that.internalHttp.put(this.internalBackEndpoint + this.internalChangePasswordEndpoint, null, { params: extraParams, observe: 'response' });
    }
    getResponseHeaderName() {
        switch (this.nvEAuthType) {
            case NVEAuthType.JWT_TOKEN: return 'jwt-auth-token';
            case NVEAuthType.X_AUTH_TOKEN: return 'x-auth-token';
        }
    }
    getRequestHeaderName() {
        switch (this.nvEAuthType) {
            case NVEAuthType.JWT_TOKEN: return 'Authorization';
            case NVEAuthType.X_AUTH_TOKEN: return 'x-auth-token';
        }
    }
    loadContext(enableReload = false) {
        const that = this;
        if (!this.getAuthContext() || enableReload) {
            return that.internalHttp
                .get(this.internalBackEndpoint + this.internalProfileEndpoint, { observe: 'response' })
                .pipe(map(r => {
                return that.saveContext(r.body, this.getToken());
            }));
        }
        else {
            return of(this.getAuthContext());
        }
    }
    getAuthContext() {
        return this.isLogged() ? this.authContext : null;
    }
    getToken() {
        const token = this.internalSessionStorageService.retrieve(this.internalAuthStorageKey);
        if (token === undefined || token === '') {
            return null;
        }
        switch (this.nvEAuthType) {
            case NVEAuthType.JWT_TOKEN: return 'Barer ' + token;
            case NVEAuthType.X_AUTH_TOKEN: return token;
        }
    }
    isLogged() {
        return this.getToken() !== null
            && this.getToken() !== ''
            && this.authContext !== null
            && this.authContext !== undefined;
    }
    hasRole(searchedRole) {
        return this.isLogged() ?
            this.authContext.rolesSet.has(searchedRole)
            : false;
    }
    hasAnyRole(roles) {
        for (const role in roles) {
            if (this.hasRole(role)) {
                return true;
            }
        }
        return false;
    }
    hasAllRoles(roles) {
        for (const role in roles) {
            if (!this.hasRole(role)) {
                return false;
            }
        }
        return true;
    }
    clearContext() {
        this.internalSessionStorageService.clear();
        this.authContext = null;
        console.log('Logout performed.');
    }
    saveContext(user, token) {
        this.internalSessionStorageService.store(this.internalAuthStorageKey, token);
        this.authContext = new NVAuth({ user, token });
        return this.authContext;
    }
    resetPasswordRequest(username) {
        const that = this;
        let resetPasswordRequestEndpoint = this.internalResetPasswordRequestEndpoint.slice();
        resetPasswordRequestEndpoint = resetPasswordRequestEndpoint.replace("${username}", username);
        return that.internalHttp.put(this.internalBackEndpoint + resetPasswordRequestEndpoint, null, { observe: 'response' });
    }
    resetPasswordPerform(username, token, password) {
        const that = this;
        let resetPasswordPerformEndpoint = this.internalResetPasswordPerformEndpoint.slice();
        resetPasswordPerformEndpoint = resetPasswordPerformEndpoint.replace("${username}", username);
        resetPasswordPerformEndpoint = resetPasswordPerformEndpoint.replace("${token}", token);
        return that.internalHttp.put(this.internalBackEndpoint + resetPasswordPerformEndpoint, password, { observe: 'response' });
    }
    firstChangePasswordPerform(username, token, password) {
        const that = this;
        let firstChangePasswordPerformEndpoint = this.internalFirstChangePasswordEndpoint.slice();
        firstChangePasswordPerformEndpoint = firstChangePasswordPerformEndpoint.replace("${username}", username);
        firstChangePasswordPerformEndpoint = firstChangePasswordPerformEndpoint.replace("${token}", token);
        console.log(password);
        return that.internalHttp.put(this.internalBackEndpoint + firstChangePasswordPerformEndpoint, password, { observe: 'response' });
    }
    verifyOTP(username, token) {
        const that = this;
        let verifyOTPEndpoint = this.internalVerifyOTPEndpoint.slice();
        verifyOTPEndpoint = verifyOTPEndpoint.replace("${username}", username);
        verifyOTPEndpoint = verifyOTPEndpoint.replace("${token}", token);
        return that.internalHttp.put(this.internalBackEndpoint + verifyOTPEndpoint, null, { observe: 'response' });
    }
    createOTP(username) {
        const that = this;
        let createOTPEndpoint = this.internalCreateOTPEndpoint.slice();
        createOTPEndpoint = createOTPEndpoint.replace("${username}", username);
        return that.internalHttp.put(this.internalBackEndpoint + createOTPEndpoint, null, { observe: 'response' });
    }
}

class NVCanActivateViaIsLoggedGuard {
    constructor(router, configuration, authService) {
        this.router = router;
        this.configuration = configuration;
        this.authService = authService;
    }
    canActivate() {
        if (this.authService.isLogged()) {
            return of(true);
        }
        if (this.authService.getToken()) {
            return this.authService.loadContext().pipe(map((auth) => {
                return this.authService.isLogged();
            }));
        }
        this.router.navigateByUrl(this.configuration.loginURL);
        return of(false);
    }
}
/** @nocollapse */ NVCanActivateViaIsLoggedGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVCanActivateViaIsLoggedGuard, deps: [{ token: i1.Router }, { token: NVAuthConfigurations }, { token: NVAuthService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ NVCanActivateViaIsLoggedGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVCanActivateViaIsLoggedGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVCanActivateViaIsLoggedGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: NVAuthConfigurations }, { type: NVAuthService }]; } });

class NVCanActivateViaHasRoleGuard {
    constructor(router, configuration, authService) {
        this.router = router;
        this.configuration = configuration;
        this.authService = authService;
    }
    canActivate(next, state) {
        const allRolesCondition = (next && next.data && next.data.auth && next.data.auth.hasAllRoles) ?
            this.authService.hasAllRoles(next.data.auth.hasAllRoles)
            : true;
        const anyRolesCondition = (next && next.data && next.data.auth && next.data.auth.hasAnyRoles) ?
            this.authService.hasAnyRole(next.data.auth.hasAnyRoles)
            : true;
        const isAuthorized = allRolesCondition || anyRolesCondition;
        if (!isAuthorized) {
            this.router.navigateByUrl(this.configuration.notAuthorizedURL);
        }
        return of(isAuthorized);
    }
}
/** @nocollapse */ NVCanActivateViaHasRoleGuard.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVCanActivateViaHasRoleGuard, deps: [{ token: i1.Router }, { token: NVAuthConfigurations }, { token: NVAuthService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ NVCanActivateViaHasRoleGuard.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVCanActivateViaHasRoleGuard, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.0", ngImport: i0, type: NVCanActivateViaHasRoleGuard, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.Router }, { type: NVAuthConfigurations }, { type: NVAuthService }]; } });

class NVAuthInterceptor {
    constructor(internalNVAuthService) {
        this.internalNVAuthService = internalNVAuthService;
    }
    intercept(req, next) {
        const token = this.internalNVAuthService.getToken();
        if (token !== null && token !== '') {
            req = req.clone({
                headers: req.headers.set(this.internalNVAuthService.getRequestHeaderName(), this.internalNVAuthService.getToken())
            });
        }
        return next.handle(req);
    }
}

/*
 * Public API Surface of nv-auth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NVAuth, NVAuthConfigurations, NVAuthInterceptor, NVAuthService, NVCanActivateViaHasRoleGuard, NVCanActivateViaIsLoggedGuard, NVEAuthType, NVProfile, NVUser };
